import { H3, H5 } from '@/components/Headings';
import { TextSmall } from '@/components/Texts';
import { colors } from '@/styles/theme/colors';
import { Stack } from '@chakra-ui/react';
import Link from 'next/link';

const RiskDisclosure = () => {
  return (
    <Stack w='full' maxW={'8xl'}>
      <Stack
        w='full'
        py={{ base: 4, md: 12 }}
        textAlign={'start'}
        spacing={2}
        maxW={'100%'}
      >
        <Stack>
          <H3>Risk Disclosure</H3>
        </Stack>
        <TextSmall>
          All terms used in this notice, which are defined in the Diment Terms
          of Use (the “Terms of Use”), have the same meaning and construction as
          in the Terms of Use.
        </TextSmall>
        <TextSmall>
          This notice is intended to provide you with information regarding the
          risks associated with Diment Services. Each Diment Service carries its
          unique set of risks. This notice offers a general overview of the
          risks that may be encountered when utilizing Diment Services.
        </TextSmall>
        <TextSmall>
          Please note that this notice does not encompass all potential risks or
          how these risks may pertain to your specific circumstances. It is of
          utmost importance that you have a comprehensive understanding of the
          risks involved before deciding to use Diment Services.
        </TextSmall>
        <H5 mt={8} fontWeight={700}>
          <H5 fontWeight={500} as={'span'} color={colors.diment.lightBlue}>
            A.
          </H5>{' '}
          Market Risks
        </H5>
        <TextSmall>
          The customer acknowledges that the creation and trading of
          cryptocurrencies entail significant risks and may result in the
          complete loss of the capital invested. Such transactions should only
          be undertaken following comprehensive consultation with a
          knowledgeable individual.
        </TextSmall>
        <TextSmall>
          Trading in Digital Assets is exposed to substantial market risk and
          price fluctuations. Significant changes in value can transpire swiftly
          and unexpectedly. Historical performance should not be considered a
          dependable predictor of future performance. The value of an investment
          and potential returns can decrease just as easily as they can
          increase, and there is no guarantee that you will recover the initial
          amount you invested.
        </TextSmall>
        <TextSmall>
          Digital Assets may lack sufficient liquidity, which can create
          challenges or even prevent you from selling or exiting a position at
          your desired time.
        </TextSmall>
        <TextSmall>
          Rapid price changes may occur at any time, including outside of normal
          business hours.
        </TextSmall>
        <TextSmall>
          {`You bear sole responsibility and liability for all activities, both
        trading and non-trading, conducted on the Site and within your Digital
        Tokens Wallet on the Site. It's also your responsibility to ensure that
        you have an accurate understanding of the status of your Diment Tokens
        on the Site, even in cases where the Site may display this information
        incorrectly.`}
        </TextSmall>
        <TextSmall>
          You also acknowledge and agree that Diment is not responsible for
          losses or complications arising from third-party transactions,
          including but not limited to issues related to legality, quality,
          delivery, or satisfaction with products purchased via Digital Token
          transfers. If you encounter any dissatisfaction with goods or services
          purchased from or sold to a third party through the Services, you must
          address those concerns directly with the relevant third-party seller
          or buyer.
        </TextSmall>
        <H5 mt={8} fontWeight={700}>
          <H5 fontWeight={500} as={'span'} color={colors.diment.lightBlue}>
            B.
          </H5>{' '}
          No Personal Advice
        </H5>
        <TextSmall>
          We do not offer personal guidance with respect to our products or
          services. Occasionally, we provide factual information, details about
          transaction processes, and information concerning potential risks.
          However, the decision to use our products or services is entirely
          yours. None of the communications or information provided by Diment
          should be interpreted as, or regarded as, investment advice, financial
          advice, trading advice, or any form of advice. It is your sole
          responsibility to assess whether any investment, investment strategy,
          or related transaction aligns with your personal investment goals,
          financial situation, and risk tolerance.
        </TextSmall>
        <TextSmall>
          We do not oversee whether your utilization of Diment Services aligns
          with your financial aspirations and objectives. The responsibility
          lies with you to evaluate if your financial means are sufficient for
          your financial dealings with us, and to gauge your risk tolerance
          concerning the products and services you engage with.
        </TextSmall>
        <H5 mt={8} fontWeight={700}>
          <H5 fontWeight={500} as={'span'} color={colors.diment.lightBlue}>
            C.
          </H5>{' '}
          No Tax, Regulatory or Legal Advice
        </H5>
        <TextSmall>
          The tax implications of Digital Assets are uncertain, and it is your
          responsibility to determine your potential tax liabilities and their
          application when conducting transactions through Diment Services. We
          strongly advise you to seek professional tax advice regarding these
          matters before engaging in any digital asset transactions. You are
          also accountable for reporting and fulfilling any tax obligations that
          may arise from your transactions on Diment Services. Please be aware
          that Diment does not provide legal or tax advice regarding these
          transactions. If you have any uncertainties about your tax status or
          obligations while using Diment Services or concerning the Digital
          Assets held in your Diment account, it is advisable to seek
          independent professional guidance.
        </TextSmall>
        <TextSmall>
          {`You understand that, in compliance with applicable laws, Diment may be
        required to report information about your transactions, transfers,
        distributions, or payments to tax or other governmental authorities.
        Similarly, in line with relevant legislation, Diment may need to
        withhold taxes related to your transactions, transfers, distributions,
        or payments. Furthermore, applicable regulations may prompt Diment to
        request additional tax-related information, certificates, or
        documentation from you. It's important to note that failing to respond
        to these requests within the specified time frame may result in Diment
        withholding taxes and remitting them to the appropriate tax authorities
        as defined by the relevant laws.`}
        </TextSmall>
        <TextSmall>
          Alterations in laws and regulations can significantly impact the value
          of Digital Assets. This risk is unpredictable and can differ from one
          market to another.Formularbeginn
        </TextSmall>
        <H5 mt={8} fontWeight={700}>
          <H5 fontWeight={500} as={'span'} color={colors.diment.lightBlue}>
            D.
          </H5>{' '}
          Fees & Charges
        </H5>
        <TextSmall>
          Our fee and cost structure is outlined{' '}
          <Link style={{ fontWeight: 800 }} href={'https://www.diment.io/fees'}>
            here
          </Link>
          . Diment reserves the right to periodically revise these fees and
          charges at its discretion.{' '}
          {`It's important to be fully informed about all applicable expenses and charges, as they can impact the profits you derive from utilizing Diment Services.`}
        </TextSmall>
        <H5 mt={8} fontWeight={700}>
          <H5 fontWeight={500} as={'span'} color={colors.diment.lightBlue}>
            E.
          </H5>{' '}
          Availability Risk
        </H5>
        <TextSmall>
          Various countries have legal requirements that may limit the products
          and services Diment can legally offer. As a result, certain products,
          services, or specific features may not be accessible or may be
          restricted in particular jurisdictions or regions or for certain
          users. Furthermore, any Diment campaigns, user competitions, or other
          promotions will not be open to, and are not designed for, users
          subject to these restrictions. Users are responsible for familiarizing
          themselves with and adhering to any limitations and requirements
          related to accessing and using Diment Services in each jurisdiction
          from which Diment Services are accessed by or on behalf of the user.
        </TextSmall>
        <TextSmall>
          Diment reserves the right to modify, change, or introduce additional
          restrictions regarding access to Diment Services at its sole
          discretion with prior notification to you of at least four weeks. Due
          to a change in the market situation, the legal conditions, supreme
          court rulings and changed circumstances or if a clause in the previous
          Restrictions has been declared invalid, DC may be faced with the
          necessity to completely or partially rewrite its restrictions during
          the duration of existing contracts. DC will expressly draw your
          attention to the new restriction and make the amended text available
          to you. DC will emphasize the new version or explain it to you. If you
          fall under the restriction and your DC account must be suspended, DC
          will give you enough lead time to prevent this through certain
          cooperative actions, if possible. DC grants you a right of objection
          and termination of the contract if you do not agree with the amended
          version of the Terms of Service. However, in the event of an
          objection, DC has a special right of termination of the contract with
          you with immediate effect. You will be given a reasonable period of
          time to submit a declaration. DC regards the continuation of the
          contractual relationship by you without objection after receipt of the
          notice as your implied consent to the amendment, change or update of
          the Terms of Service and restrictions after expiry of the declaration
          period. In this case, the modified version will take effect from the
          date indicated.
        </TextSmall>
        <TextSmall>
          We cannot guarantee the continuous availability of Diment Services at
          specific times, and Diment Services may be vulnerable to unforeseen
          service disruptions or network congestion. Consequently, it may not
          always be possible for you to buy, sell, store, transfer, send, or
          receive Diment Tokens exactly when you intend to do so. However, we
          aim for an availability of at least 96 % on an annual average plus
          maintenance window. In the event of regular maintenance, we will
          announce this with lead time.
        </TextSmall>
        <H5 mt={8} fontWeight={700}>
          <H5 fontWeight={500} as={'span'} color={colors.diment.lightBlue}>
            F.
          </H5>{' '}
          Security Risk & Risks related to Digital Assets
        </H5>
        <TextSmall>
          Diment cannot completely eliminate all security risks. It is your
          responsibility to safeguard your Diment Account password, and you may
          bear responsibility for all transactions conducted through your Diment
          Account, whether or not you authorized them. Keep in mind that
          transactions involving Digital Assets may be irreversible, and losses
          arising from fraudulent or unauthorized transactions may not be
          retrievable.
        </TextSmall>
        <TextSmall>
          Given the inherent nature of Digital Assets and their underlying
          technologies, there are various inherent risks, including but not
          limited to:
        </TextSmall>
        <TextSmall pl={5}>
          a. Given the inherent nature of Digital Assets and their underlying
          technologies, there are various inherent risks, including but not
          limited to:
        </TextSmall>
        <TextSmall pl={5}>
          b. transactions in Digital Assets being irreversible. Consequently,
          losses due to fraudulent or accidental transactions may not be
          recoverable;
        </TextSmall>
        <TextSmall pl={5}>
          c. technological development leading to the obsolescence of a Digital
          Asset;
        </TextSmall>
        <TextSmall pl={5}>
          d. delays causing a transactions not be settled on the scheduled
          delivery date; and
        </TextSmall>
        <TextSmall pl={5}>
          e. attacks on the protocol or technologies on which a Digital Asset
          depends, including, but not limited to: i. distributed denial of
          service; ii. sybil attacks; iii. phishing; iv. social engineering; v.
          hacking; vi. smurfing; vii. malware; viii. double spending; ix.
          majority-mining, consensus-based or other mining attacks; x.
          misinformation campaigns; xi. forks; and xii. spoofing.
        </TextSmall>
        <H5 mt={8} fontWeight={700}>
          <H5 fontWeight={500} as={'span'} color={colors.diment.lightBlue}>
            G.
          </H5>{' '}
          Communication Risks
        </H5>
        <TextSmall>
          {`When you engage in electronic communication with us, it's important to
        recognize that electronic communications can encounter failures, delays,
        security vulnerabilities, and may not always reach their intended
        recipients. We do our best to make our communications more secure
        through encryption wherever possible.`}
        </TextSmall>
        <H5 mt={8} fontWeight={700}>
          <H5 fontWeight={500} as={'span'} color={colors.diment.lightBlue}>
            H.
          </H5>{' '}
          Currency
        </H5>
        <TextSmall>
          Currency exchange fluctuations will impact your gains and losses.
        </TextSmall>
        <H5 mt={8} fontWeight={700}>
          <H5 fontWeight={500} as={'span'} color={colors.diment.lightBlue}>
            J.
          </H5>{' '}
          Third Party Risk
        </H5>
        <TextSmall>
          Third parties, including payment providers, custodians, and banking
          partners, may play a role in delivering Diment Services. You may be
          bound by the terms and conditions of these third parties, and Diment
          may not be held responsible for any losses that may result from the
          actions of these third parties.
        </TextSmall>
        <Stack maxW={'8xl'} spacing={4} textAlign={'left'} w='full'>
          <TextSmall textAlign={'end'} fontWeight={700}>
            7.12.2023
          </TextSmall>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default RiskDisclosure;
